// extracted by mini-css-extract-plugin
export default {"wrapper":"footer_wrapper__1FI+q","container":"footer_container__C+Ltd"};